var FiltersForm = (function () {
    return {
        url: '',
        menuOpened: false,
        init: function () {
            var self = this;
            $(document).ready(function () { self.datePickerInit(); }); // Initialize date range picker
            $(document).keyup(function (e) { // If ESC key is pressed, close right panel
                if (e.keyCode == 27 && self.menuOpened) { // escape key maps to keycode `27`
                    self.closeRightMenu();
                }
            });
            if (localStorage.getItem('ConfigEndpoints') !== undefined) {
                var ConfigEndpoints = JSON.parse(localStorage.getItem('ConfigEndpoints'));
                this.url = ConfigEndpoints["analytics_url"];
            } else this.url = "";
            // this.url = 'http://localhost:9090/dashboard/';

            var selectedGroup = self.setLocationGroups(); // Initialize location groups dropdown
            self.setLocations(); // Initialize locations dropdown
            self.setTimeZones(); // Initialize time zones dropdown
        },
        getDefaultRange: function () {
            try {
                var srcftl = localStorage.getItem('srcftl');
                if (srcftl) { // Check if exist previous search filters
                    var range = JSON.parse(srcftl);
                    return { desc: range.desc, start: moment(range.since, 'YYYY-MM-DDTHH:mm:ss'), end: moment(range.until, 'YYYY-MM-DDTHH:mm:ss'), nasid: JSON.parse(range.nasid), select2_nasid: (range.select2_nasid) ? JSON.parse(range.select2_nasid) : '', group: range.group, select2_group: (range.select2_group) ? (range.select2_group) : '', activefilters: range.activefilters, chosenLabel: range.chosenLabel, timezone: range.timezone, select2_timezone: (range.select2_timezone) ? JSON.parse(range.select2_timezone) : '' };
                }
                else {
                    var timezone = $('#selecttimezone').val();
                    return { desc: 'Last 2 weeks &minus; All Locations', start: moment().add(-14, 'day').startOf('day'), end: moment().endOf('day'), nasid: '', select2_nasid: '', group: '', select2_group: '', activefilters: 0, chosenLabel: 'Last 2 weeks', timezone: timezone, select2_timezone: '' };
                }
            }
            catch (e) {
                console.log(e);
                var timezone = $('#selecttimezone').val();
                return { desc: 'Last 2 weeks &minus; All Locations', start: moment().add(-14, 'day').startOf('day'), end: moment().endOf('day'), nasid: '', select2_nasid: '', group: '', select2_group: '', activefilters: 0, chosenLabel: 'Last 2 weeks', timezone: timezone, select2_timezone: '' };
            }
        },

        setTimeZones: function () {
            var timezoneList = JSON.parse(localStorage.getItem('tz')); // Get previously stored locations
            var timezone_result = timezoneList.map((t) => { return { id: t.id, text: t.id, offset: t.offset }; });

            try {
                $('#selecttimezone').select2();
                $('#selecttimezone').select2('destroy');
            } catch (e) { }

            $('#selecttimezone').select2({ // Initialize select2 component with single choice option
                data: timezone_result, // Pass dataset
                multiple: false, // Enable multiple selection

            });

            $('#selecttimezone').on('select2:select', function (e) {
                var $select = $(this);
                var selval = $select.select2('val');
                if (selval) {
                    $('#selecttimezone').val(selval).change();
                } else {
                    $('#selecttimezone').val('LOCAL').change();
                }
            });
            var defRange = this.getDefaultRange(); // Get defaults or previous search values

            if (defRange.select2_timezone) $('#selecttimezone').val(defRange.select2_timezone).change(); // Select the previus selected timezone
        },

        setLocationGroups: function () {
            var lgList = JSON.parse(localStorage.getItem('locGroups')); // Get previously stored location groups
            var lg_result = lgList.map((l) => { return { id: l.id, text: l.name }; });

            try {
                $('#selectlocgroup').select2();
                $('#selectlocgroup').select2('destroy');
            } catch (e) { }

            $('#selectlocgroup').select2({ // Initialize select2 component with multiple choice option
                data: lg_result, // Pass dataset
                multiple: false, // Enable multiple selection
            });

            var selectedGroup = '';

            $('#selectlocgroup').on('select2:select', function (e) {
                var $select = $(this);
                var selval = $select.select2('val');
                if (selval) {
                    $('#selectlocgroup').val(selval).change();
                    selectedGroup = selval;
                    FiltersForm.setLocations(selectedGroup);
                } else {
                    $('#selectlocgroup').val('NONE').change();
                }
            });

            var defRange = this.getDefaultRange(); // Get defaults or previous search values

            if (defRange.select2_group) {
                $('#selectlocgroup').val(defRange.select2_group).change(); // Select the previus selected nasid
                selectedGroup = defRange.select2_group;
            }

            return selectedGroup;

        },

        setLocations: function (selectedGroup) {

            var defRange = this.getDefaultRange(); // Get defaults or previous search values
            if (defRange.select2_group != '' && selectedGroup === undefined) {
                selectedGroup = defRange.select2_group;
            }

            var locList = JSON.parse(localStorage.getItem('locs')); // Get previously stored locations

            locList = locList.filter(l => l.location_group_id === selectedGroup);

            var loc_result = locList.map((l) => { return { id: l.id, text: l.name, lg_id: l.location_group_id }; });

            try {
                $('#selectloc').select2();
                $('#selectloc').select2('destroy');
                $('#selectloc').html('');
            } catch (e) {
                console.log(e);
            }

            $('#selectloc').select2({ // Initialize select2 component with multiple choice option
                data: loc_result, // Pass dataset
                multiple: true, // Enable multiple selection
            });

            $('#selectloc').on('select2:select', function (e) {
                var $select = $(this);
                var selvals = $select.select2('val');
                if (selvals.length > 1) {
                    $('#selectloc').val(selvals).change();
                }
            });

            if (defRange.select2_nasid) $('#selectloc').val(defRange.select2_nasid).change(); // Select the previus selected nasid

        },
        datePickerInit: function () {
            try { for (var el of $('.daterangepicker.dropdown-menu.ltr.opensright')) el.remove(); } catch (e) { } // Remove previous instances of daterangepicker

            var defRange = this.getDefaultRange(); // Get defaults or previous search values

            var start = dateTransform(defRange.start);
            var end = dateTransform(defRange.end);
            var chosenLabel = defRange.chosenLabel;

            function cb(start, end) {
                $('#reportrange span').html(start.format('MMM DD YYYY, HH:mm:ss') + ' - ' + end.format('MMM DD YYYY, HH:mm:ss'));
            }

            var lastDay = dateTransform(moment().add(-1, 'day').endOf('day'));
            var toDay = dateTransform(moment().endOf('day'));

            $('#reportrange').daterangepicker({ // Initialize date range picker
                locale: { format: 'DD-MM-YYYY HH:mm:ss' },
                startDate: start,
                endDate: end,
                maxDate: dateTransform(moment().endOf('day')),
                timePicker: true,
                timePicker24Hour: true,
                timePickerSeconds: true,
                opens: "right",
                autoApply: true,
                ranges: {
                    'Today': [dateTransform(moment().startOf('day')), toDay],
                    'Yesterday': [dateTransform(moment().add(-1, 'day').startOf('day')), lastDay],
                    'Last week': [dateTransform(moment().add(-7, 'day').startOf('day')), toDay],
                    'Last 2 weeks': [dateTransform(moment().add(-14, 'day').startOf('day')), toDay],
                    'Last Month': [dateTransform(moment().add(-31, 'day').startOf('day')), toDay]
                }
            }, cb);

            cb(start, end); // Init daterangepicker label

            $('#reportrange').data('daterangepicker').chosenLabel = chosenLabel;

            function dateTransform(date) { // Function to hack in known format date
                return moment(date.format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss');
            }
        },
        getPeriod: function () { // Function to get selected date time period, and time grain
            var since, until, desc, emptyval = false, time_grain_sqla = "hour";

            var drp = $('#reportrange').data('daterangepicker');

            since = drp.startDate.format('YYYY-MM-DDTHH:mm:ss');
            until = drp.endDate.format('YYYY-MM-DDTHH:mm:ss');
            var chosenLabel = drp.chosenLabel || 'Last 2 weeks';

            switch (chosenLabel) {
                case 'Today': {
                    desc = 'Today';
                    time_grain_sqla = "hour";
                    break;
                }
                case 'Yesterday': {
                    desc = 'Yesterday';
                    time_grain_sqla = "hour";
                    break;
                }
                case 'Last week': {
                    desc = 'Last Week';
                    time_grain_sqla = "hour";
                    break;
                }
                case 'Last 2 weeks': {
                    desc = 'Last 2 Weeks';
                    time_grain_sqla = "day";
                    break;
                }
                case 'Last Month': {
                    desc = 'Last Month';
                    time_grain_sqla = "day";
                    break;
                }
                case 'Custom Range':
                default: {
                    var from_date = drp.startDate;
                    var to_date = drp.endDate;
                    var date_diff = to_date.diff(from_date, 'hour');
                    if (date_diff >= 0) {
                        //var hours_diff = moment.duration(date_diff).asHours();
                        //time_grain_sqla = this.getTimeGrain(hours_diff);
                        time_grain_sqla = this.getTimeGrain(date_diff);

                        desc = from_date.format("MMM DD YYYY, HH:mm:ss") + " - " + to_date.format("MMM DD YYYY, HH:mm:ss");
                    }
                    else { // Based on daterangepicker component, will never happen
                        $("#search-error").modal('show');
                        emptyval = true;
                    }
                    break;
                }
            }

            return { since: since, until: until, desc: desc, emptyval: emptyval, time_grain_sqla: time_grain_sqla };
        },
        getTimeGrain: function (value) {
            var tg = 'hour';

            if (value < 359) // Less or equal than 2 weeks
                tg = 'hour';
            else if (value >= 359) // Greater than a 2 weeks
                tg = 'day';

            return tg;
        },
        search: function (dashboard) {
            try {
                var superset = new Superset();
                var sliceList = dashboard.sliceList; // Dashboard data
                this.closeRightMenu(); // Close the right filter panel

                if (sliceList.length > 0) { // If any data create chart
                    var emptyval = false;
                    var desc = "", since, until, nasid, select2_nasid = '', select2_group = '', select2_timezone = '', time_grain_sqla;
                    var pars = [];

                    //var period = this.getPeriod($('#perdiod-selector').val());
                    var period = this.getPeriod(); // Get selected date time period and timegrain

                    emptyval = period.emptyval;
                    since = period.since;
                    until = period.until;
                    desc = period.desc;
                    time_grain_sqla = period.time_grain_sqla;

                    if (!emptyval) {
                        var chosenLabel = $('#reportrange').data('daterangepicker').chosenLabel;
                        var activefilters = 0;
                        if (chosenLabel !== 'Last 2 weeks') // Check if a period different from default is selected
                            if (chosenLabel !== undefined)
                                activefilters = 1;

                        if ($("#selecttimezone").select2('val')) {  // Check if any group is selected
                            if ($("#selecttimezone").select2('val') !== 'LOCAL') {
                                select2_timezone = $("#selecttimezone").select2('val');
                                var timezoneList = JSON.parse(localStorage.getItem('tz'));
                                if (select2_timezone) {
                                    var tmp_tz = timezoneList.filter(t => t.id === select2_timezone)[0].offset;
                                    timezone = tmp_tz;
                                } else {
                                    timezone = '';
                                }
                                var selectData = $("#selecttimezone").select2('data');
                                desc += ' &minus; ' + selectData.map((o) => { return o.text; }).join(', ');
                                activefilters++;
                            }
                            else {
                                timezone = '';
                                desc += ' &minus; Local Time Zone';
                            }
                        }
                        else {
                            timezone = '';
                            desc += ' &minus; Local Time Zone';
                        }

                        if ($("#selectlocgroup").select2('val')) {  // Check if any group is selected
                            if ($("#selectlocgroup").select2('val') != 'NONE') {
                                select2_group = $("#selectlocgroup").select2('val');
                                var lgList = JSON.parse(localStorage.getItem('locGroups'));
                                if (select2_group) {
                                    var tmp_group = lgList.filter(l => l.id === select2_group);
                                    group = tmp_group[0].id;
                                }
                                var selectData = $("#selectlocgroup").select2('data');
                                desc += ' &minus; ' + selectData.map((o) => { return o.text; }).join(', ');
                                activefilters++;
                                var locList = JSON.parse(localStorage.getItem('locs'));
                            }
                            else {
                                group = 'NONE';
                            }
                        }
                        else {
                            group = 'NONE';
                        }

                        if ($("#selectloc").select2('val')) {  // Check if any nasid is selected
                            if ($("#selectloc").select2('val').length > 0) {
                                select2_nasid = $("#selectloc").select2('val');
                                nasid = [];
                                var locList = JSON.parse(localStorage.getItem('locs'));
                                for (var sn of select2_nasid) {
                                    var tmp_nasid = locList.filter(l => l.id === sn);
                                    for (var tn of tmp_nasid) {
                                        nasid.push(tn.id);
                                    }
                                }
                                var selectData = $("#selectloc").select2('data');
                                desc += ' &minus; ' + selectData.map((o) => { return o.text; }).join(', ');
                                activefilters++;
                            }
                            else {
                                nasid = '';
                                desc += ' &minus; All locations';
                            }
                        }
                        else {
                            nasid = '';
                            desc += ' &minus; All locations';
                        }

                        var srcftl = { // Create search filter object
                            desc: desc,
                            since: since,
                            until: until,
                            nasid: JSON.stringify(nasid),
                            select2_nasid: JSON.stringify(select2_nasid),
                            group: group,
                            select2_group: select2_group,
                            timezone: timezone,
                            select2_timezone: JSON.stringify(select2_timezone),
                            activefilters: activefilters.toString(),
                            chosenLabel: period.desc
                        };

                        localStorage.setItem('srcftl', JSON.stringify(srcftl)); // Store in local storege current search
                        $('.actfltrs').html((activefilters).toString());

                        $('.descsearch').html(desc);

                        var avlsls = JSON.parse(localStorage.getItem('avlsls'));

                        for (var sl of sliceList) { // Cycle on current slices
                            var current_code = (sl.get_precision) ? ((sl.get_precision) ? sl.code + superset.getPrecision() : sl.code) : sl.code;
                            var max_last_week = (sl.max_last_week) ? sl.max_last_week : false;
                            var currsls = avlsls.find((o) => { return o.code === current_code; });
                            var url = this.url + current_code; // Build API url to call
                            var chCont = {
                                "container": dashboard.options.container,
                                "class": dashboard.options.class + sl.class,
                                "available": currsls.available,
                                "type": sl.type,
                                "chartId": superset.stringFormat(dashboard.options.chartId, current_code),
                                "chartTitle": currsls.name,
                                "realtime": (sl.realtime) ? sl.realtime : false,
                                "analysis_realtime": (sl.analysis_realtime) ? sl.analysis_realtime : false,
                                "sectionname": dashboard.options.sectionname,
                                "key_as_zone": (sl.key_as_zone) ? sl.key_as_zone : false,
                                "x_as_zone": (sl.x_as_zone) ? sl.x_as_zone : false,
                                "y_as_zone": (sl.y_as_zone) ? sl.y_as_zone : false,
                                "original_code": sl.code,
                                "suffix": (sl.suffix) ? sl.suffix : '',
                                "exception": (sl.exception) ? sl.exception : '',
                                "slice_url": url,
                                "no_data_box": (sl.no_data_box) ? sl.no_data_box !== '0' : true,
                                "fill_range_value": (sl.fill_range_value) ? '1' : '0',
                                "show_all_tooltips": (sl.show_all_tooltips) ? sl.show_all_tooltips !== '0' : true,
                                "chartTitleClass": 'chart-title',
                                "ignoreFilters": (sl.ignoreFilters) ? sl.ignoreFilters : false
                            }; // Build parameters for analysis call and chart options

                            $('#' + chCont.chartId + '_container').removeClass('myHide');
                            var visible = true;

                            if (sl.type === 'cal_heatmap') {
                                visible = true;
                            } else {
                                if (sl.visibility) {
                                    if (sl.min_week)
                                        if (sl.min_week) {
                                            var from_date = moment(period.since);
                                            var to_date = moment(period.until);
                                            var date_diff = to_date.diff(from_date, 'day');
                                            if (date_diff >= 7) {
                                                visible = true;
                                                time_grain_sqla = 'day';
                                            }
                                            else
                                                visible = false;
                                        }
                                        else {
                                            if (sl.visibility === 'today') {
                                                var since_day = moment(period.since).format('YYYY-MM-DD');
                                                var until_day = moment(period.until).format('YYYY-MM-DD');
                                                var today = moment().format('YYYY-MM-DD');
                                                if (until_day === today && since_day === today) visible = true;
                                                else visible = false;
                                            } else if (sl.visibility === 'no-today') {
                                                var since_day = moment(period.since).format('YYYY-MM-DD');
                                                var until_day = moment(period.until).format('YYYY-MM-DD');
                                                var today = moment().format('YYYY-MM-DD');
                                                if (until_day === today && since_day === today) visible = false;
                                                else visible = true;
                                            } else visible = visible = (time_grain_sqla === sl.visibility) ? true : false;
                                        }
                                    else {
                                        if (sl.visibility === 'today') {
                                            var since_day = moment(period.since).format('YYYY-MM-DD');
                                            var until_day = moment(period.until).format('YYYY-MM-DD');
                                            var today = moment().format('YYYY-MM-DD');
                                            if (until_day === today && since_day === today) visible = true;
                                            else visible = false;
                                        } else if (sl.visibility === 'no-today') {
                                            var since_day = moment(period.since).format('YYYY-MM-DD');
                                            var until_day = moment(period.until).format('YYYY-MM-DD');
                                            var today = moment().format('YYYY-MM-DD');
                                            if (until_day === today && since_day === today) visible = false;
                                            else visible = true;
                                        } else visible = visible = (time_grain_sqla === sl.visibility) ? true : false;
                                    }
                                }
                                else {
                                    if (sl.min_week)
                                        if (sl.min_week) {
                                            var from_date = moment(period.since);
                                            var to_date = moment(period.until);
                                            var date_diff = to_date.diff(from_date, 'day');
                                            visible = (date_diff >= 7) ? true : false;
                                        }
                                }
                            }

                            if (visible) { // Check if time granularity according to current analysis
                                var pars = {};
                                var filters = [];

                                // Filter is on nasid
                                var canFilterNasid = (sl.nasid_filter) ? (sl.nasid_filter === '1' ? true : false) : true;
                                if (nasid) {
                                    if (currsls.filters && canFilterNasid) {
                                        if (currsls.filters['nasid']) {
                                            if (nasid.length === 1) {
                                                if (!sl.ispresence) {
                                                    filters.push({ "op": "==", "col": currsls.filters['nasid'], "val": nasid[0] }); // Filter on single nasid
                                                }
                                                else {
                                                    filters.push({ "op": "in", "col": currsls.filters['nasid'], "val": 'null_location' });
                                                }
                                            }
                                            else if (nasid.length > 1) {
                                                if (!sl.ispresence) {
                                                    filters.push({ "op": "in", "col": currsls.filters['nasid'], "val": nasid }); // Filter on multiple nasid
                                                }
                                                else {
                                                    filters.push({ "op": "in", "col": currsls.filters['nasid'], "val": 'null_location' });
                                                }
                                            }
                                        }
                                    }
                                }

                                // if === 'NONE' will just display 0 as result, or no data
                                if (group != '') {
                                    if (currsls.filters['location_group']) {
                                        filters.push({ "op": "==", "col": currsls.filters['location_group'], "val": group })
                                    }
                                }

                                if (nasid) {
                                    $('.noLocs').html(`( ${nasid.length} )`);
                                }
                                else {
                                    var locs = localStorage.getItem('locs');
                                    locs = (locs) ? JSON.parse(locs) : '';
                                    $('.noLocs').html(`( ${locs.length} )`);
                                }

                                if (sl.cj_filter) {
                                    var current_journey = JSON.parse(localStorage.getItem('current_journey'));
                                    filters.push({ "op": "==", "col": sl.cj_filter, "val": current_journey.cj_id });
                                }

                                if (sl.custom_filter) {
                                    switch (sl.custom_filter) {
                                        case 'link': {
                                            var link = JSON.parse(localStorage.getItem('current_journey_link'));
                                            filters.push({ "op": "==", "col": "link", "val": link.link_id });
                                            break;
                                        }
                                        case 'node_in': {
                                            var node = JSON.parse(localStorage.getItem('current_journey_node'));
                                            filters.push({ "op": "==", "col": "to_node", "val": node.node_id });
                                            break;
                                        }
                                        case 'node_out': {
                                            var node = JSON.parse(localStorage.getItem('current_journey_node'));
                                            filters.push({ "op": "==", "col": "from_node", "val": node.node_id });
                                            break;
                                        }
                                    }
                                }

                                if ((sl.realtime && sl.realtime === true) || (sl.analysis_realtime && sl.analysis_realtime === true)) { // If analysis is in realtime there aren't filters on time
                                    pars = {
                                        "until": moment().add(1, 'hour'),
                                        "filters": filters
                                    };
                                } else if (sl.type === 'cal_heatmap') {
                                    pars = {
                                        "since": moment(since, 'YYYY-MM-DDTHH:mm:ss').add(-6, 'months').format('YYYY-MM-DDTHH:mm:ss'),
                                        "until": until.format('YYYY-MM-DDTHH:mm:ss'),
                                        "filters": filters
                                    };
                                }
                                else if (sl.exception) {
                                    if (sl.exception === 'only_lastweek') {
                                        pars = {
                                            "since": moment().add(-1, 'weeks').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                                            "until": moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                                            "filters": filters
                                        };
                                    }
                                }
                                else {
                                    if (max_last_week) {
                                        var end = moment(until, 'YYYY-MM-DDTHH:mm:ss');
                                        var start = moment(since, 'YYYY-MM-DDTHH:mm:ss');
                                        var dateDiff = end.diff(start, 'day');
                                        if (dateDiff > 7)
                                            since = end.add(-7, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                                        time_grain_sqla = 'hour';
                                    }
                                    pars = {
                                        "filters": filters,
                                        "since": since,
                                        "until": until,
                                        "time_grain_sqla": time_grain_sqla
                                    };
                                }

                                if (sl.limit) pars[sl.limit.name] = sl.limit.value;

                                var stopTO = stopTracking;
                                stopTO.resetTimeouts(); // Remove previous timeouts instances
                                $('a.nav-link.m-tabs__link').off('click', function () { });
                                localStorage.removeItem(chCont.chartId + '_selected_mac');
                                $('.r_time_table').html('');

                                if (sl.cj_where) {
                                    if (sl.cj_where === '1') {
                                        var current_journey = JSON.parse(localStorage.getItem('current_journey'));
                                        pars['where'] = `end_ts - start_ts < interval '${current_journey.cj_data.repeatTime}'`;
                                    }
                                }

                                if (sl.cj_where_global) {
                                    if (sl.cj_where_global === '1') {
                                        var customer_journey = JSON.parse(localStorage.getItem('customer_journey'));
                                        pars['where'] = customer_journey.filter(function (c) { return c.enabled; }).map(function (e) {
                                            return `(timestamp > now() - interval '${e.repeatTime}' and journey_id = ${e.id})`
                                        }).join(' or ');
                                    }
                                }

                                pars['locations'] = [];
                                pars['locationGroups'] = [];
                                if (pars['filters'].length != 0) {
                                    for (var f of pars['filters']) {
                                        if (f.col === currsls.filters['nasid']) {
                                            if (f.op === 'in') {
                                                pars['locations'] = f.val
                                            } else if (f.op === '==') {
                                                pars['locations'].push(f.val);
                                            }
                                        }
                                        if (f.col === currsls.filters['location_group']) {
                                            if (f.op === '==') {
                                                pars['locationGroups'].push(f.val);
                                            }
                                        }
                                    }
                                }

                                var dateFormat = 'YYYY-MM-DDTHH:mm:ss';

                                pars['since'] = moment.parseZone(moment(pars['since']).format(dateFormat), dateFormat).valueOf();
                                pars['until'] = moment.parseZone(moment(pars['until']).format(dateFormat), dateFormat).valueOf();
                                pars['offset'] = timezone === '' || timezone === 'LOCAL' ? (moment().utcOffset()) / 60 : timezone;

                                pars['filters'] = {}
                                delete pars['time_grain_sqla']

                                if (pars['locationGroups'].length === 0 || pars['locationGroups'][0] === 'NONE' || !pars.filters) {
                                    superset.addNoLocationGroup(chCont);
                                } else {
                                    var slice = new Slice(url, chCont, JSON.stringify(pars));
                                    slice.init(); // Render slice
                                }

                            }
                            else { // If time granularity is not respect current analysis
                                var msg = false;
                                if (sl.message) // If message is true show an info box
                                    if (sl.message === true)
                                        superset.addWrongRange(chCont, sl.visibility, (sl.min_week) ? sl.min_week : false);
                                    else
                                        $('#' + chCont.chartId + '_container').addClass('myHide');
                                else // Hide current analysis
                                    $('#' + chCont.chartId + '_container').addClass('myHide');
                            }
                        }
                    }
                    else {
                        $("#search-error").modal('show');
                    }
                }
                else
                    console.log("NO DATA FOUND");
            }
            catch (e) {
                console.log(e.message);
            }
        },
        openRightMenu: function () {
            if (!this.menuOpened) {
                $('#rightMenu').show();
                this.menuOpened = true;
            } else {
                $('#rightMenu').hide(200);
                this.closeRightMenu();
            }
        },
        closeRightMenu: function () {
            $('#rightMenu').hide(200);
            this.menuOpened = false;
        }
    };

})(FiltersForm || {})